import Box from "@mui/material/Box";
import { Tooltip } from "@mui/material";
import React from "react";

export default function TrackerIcon(props: { size?: number; title?: string; sx?: any }) {
    const size = props.size || 28;

    const label = props.title ?? "tracker.gg";
    const icon = (
            <Box
                component="svg"
                viewBox="0 0 32 32"
                sx={{
                    width: size,
                    height: size,
                    minWidth: size,
                    minHeight: size,
                    display: "block",
                    ...props.sx,
                }}
            >
                <rect width="32" height="32" rx="7" fill="#FF6B00" />
                <circle cx="16" cy="16" r="9.2" fill="none" stroke="#fff" strokeWidth="2.2" />
                <circle cx="16" cy="16" r="4.4" fill="none" stroke="#fff" strokeWidth="2.2" />
                <circle cx="16" cy="16" r="1.5" fill="#fff" />
                <path d="M16 5.6v4.2M16 22.2v4.2M5.6 16h4.2M22.2 16h4.2" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
            </Box>
    );
    if (props.title === "") return icon;
    return (
        <Tooltip title={label} followCursor>
            {icon}
        </Tooltip>
    );
}
